import { useState } from "react";
import MultiStepLaout from "../../../layout/multiStepLayout";
import { Steps } from "../../../layout/multiStepLayout/multiStep";
import { useNavigate } from "react-router";
import { DataMapping } from "../dataMapping";
import IntegrationConnectionSuccesful from "../success";
import IntegrationConnectionFailed from "../failed";
import TestConnectionModule from "../testConnection";
import SelectSheet from "./selectSheet";

export default function GoogleSheetIntegration() {
  const [currentPage, setCurrentPage] = useState("select-sheet");
  const [connectionStatus, setConnectionStatus] = useState<string>("");
  const data: Steps[] = [
    {
      title: "Authenticate",
      subtitle: "Connect your Google account",
      pageId: "authenticate",
    },
    {
      title: "Select sheet",
      subtitle: "Choose the sheet you want to sync",
      pageId: "select-sheet",
    },
    {
      title: "Data mapping",
      subtitle: "Match your columns to contact fields",
      pageId: "data-mapping",
    },
    {
      title: "Test connection",
      subtitle: "Make sure everything syncs correctly",
      pageId: "test-connection",
    },
  ];
  const navigate = useNavigate();

  const conditionalComponent = () => {
    switch (currentPage) {
      case "authenticate":
        return <div>Authentication Component</div>;
      case "data-mapping":
        return (
          <DataMapping
            type="Google sheet"
            subText="Match your columns to contact fields"
            onSubmit={() => setCurrentPage("test-connection")}
            shouldGoBack
            backFunction={() => setCurrentPage("select-sheet")}
          />
        );
      case "select-sheet":
        return <SelectSheet submitFunction={setCurrentPage} />;
      case "test-connection":
        return connectionStatus === "success" ? (
          <IntegrationConnectionSuccesful
            onSubmit={setConnectionStatus}
            onBack={setCurrentPage}
            parameters={["Connected to: Contacts", "Sheet page: Sales"]}
            type="Google sheet"
          />
        ) : connectionStatus === "failed" ? (
          <IntegrationConnectionFailed
            onSubmit={setConnectionStatus}
            onBack={setCurrentPage}
          />
        ) : (
          <TestConnectionModule
            onBack={setCurrentPage}
            onSubmit={setConnectionStatus}
            type="Google sheet"
          />
        );
      default:
        return null;
    }
  };
  return (
    <MultiStepLaout
      multiStep={data}
      pageInfo={{
        title: "Google Sheet Integration",
        subtitle: "Follow these simple steps",
        customStyle: {
          headerTextContainerStyle: "!w-[215px]",
          stepWidth: "206px",
        },
      }}
      currentPage={currentPage}
      closeFunction={() => navigate("/campaigns")}
    >
      {conditionalComponent()}
    </MultiStepLaout>
  );
}
